import { render } from "./PriorityCases.vue?vue&type=template&id=a29cd32e"
import script from "./PriorityCases.vue?vue&type=script&lang=js"
export * from "./PriorityCases.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/cases/PriorityCases.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a29cd32e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a29cd32e', __exports__)) {
    console.log('reload')
    api.reload('a29cd32e', __exports__)
  }
  
  module.hot.accept("./PriorityCases.vue?vue&type=template&id=a29cd32e", () => {
    console.log('re-render')
    api.rerender('a29cd32e', render)
  })

}


export default __exports__